import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from "@angular/core";
import { isEmptyValue, isNotEmptyValue } from "kwikid-toolkit";
import { throwErrorMessage } from "../../../helpers/kwikui.common.helpers";
import { DEFAULT_VALUES, VALIDATE_KEY_VALUES } from "./button.constants";
import {
  TKwikUIButtonAppearance,
  TKwikUIButtonShape,
  TKwikUIButtonSize,
  TKwikUIButtonType
} from "./button.definitions";
import { isValidKeyValue } from "./button.validation";

@Component({
  selector: "kwikui-button",
  templateUrl: "./button.component.html",
  styleUrls: ["./button.component.scss"]
})
export class KwikUIButtonComponent implements OnInit, OnChanges {
  @Input() appearance: TKwikUIButtonAppearance = DEFAULT_VALUES.appearance;

  @Input() class: string = DEFAULT_VALUES.class;

  @Input() disabled: boolean = DEFAULT_VALUES.disabled;

  @Input() icon: string = DEFAULT_VALUES.icon;

  @Input() iconRight: string = DEFAULT_VALUES.iconRight;

  @Input() id: string = DEFAULT_VALUES.id;

  @Input() label: string = DEFAULT_VALUES.label;

  @Input() shape: TKwikUIButtonShape = DEFAULT_VALUES.shape;

  @Input() showLoader: boolean = DEFAULT_VALUES.showLoader;

  @Input() size: TKwikUIButtonSize = DEFAULT_VALUES.size;

  @Input() styles: string = DEFAULT_VALUES.styles;

  @Input() type: TKwikUIButtonType = DEFAULT_VALUES.type;

  @Input() pseudoHover: boolean = DEFAULT_VALUES.pseudoHover;

  @Output() onClick = new EventEmitter<any>();

  showIconButton = false;

  constructor() {}

  ngOnInit(): void {
    this.evaluateShowIconButton();
  }

  ngOnChanges(changes: SimpleChanges) {
    for (const change of Object.entries(changes)) {
      const key: string = change[0];
      const value: any = change[1].currentValue;
      this.validateInputProperty(key, value);
    }

    this.evaluateShowIconButton();
  }

  private validateInputProperty(key: string, value: any): void {
    if (VALIDATE_KEY_VALUES[key] && !isValidKeyValue(key, value)) {
      this[key] = DEFAULT_VALUES[key];
      throwErrorMessage(
        "kwikui-button",
        this.id,
        key,
        value,
        DEFAULT_VALUES[key]
      );
    }
  }

  handleOnClick(e: any) {
    this.onClick.emit(e);
  }

  private evaluateShowIconButton(): void {
    this.showIconButton =
      isEmptyValue(this.label) &&
      isEmptyValue(this.iconRight) &&
      isNotEmptyValue(this.icon);
  }
}
